import React, { useContext } from 'react'
import { Table } from 'components'
import { createAssessmentsHooks } from '.'
import { dataGridModel } from 'keys'
import { CreateAssessmentsContext } from './CreateAssessmentsContext'

const Affiliations = () => {
    const {
        selectedTestTakers, setSelectedTestTakers,
        learningGroups, learningGroupStructureOptions,
        learningGroupOpen, setLearningGroupOpen, page, setPage, pageSize, setPageSize, searchVal, setSearchVal, sorting, setSorting, setClassIndexTab } = useContext(CreateAssessmentsContext)
    const groupColumns = createAssessmentsHooks.useGroupsTableColumns()
    const testTakersColumns = createAssessmentsHooks.useTestTakersTableColumns()

    const currentGroup = learningGroups?.data?.find(item => item.id == learningGroupOpen) || []

    return (
        <div className='school-classes-table'>
            <Table
                tableH={"100%"}
                withTitle
                loading={learningGroups.isFetching}
                data={{ results: learningGroups.data || [] }}
                columns={groupColumns}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                rowOpen={learningGroupOpen}
                setRowOpen={setLearningGroupOpen}
                searchVal={searchVal}
                setSearchVal={setSearchVal}
                sorting={sorting}
                setSorting={setSorting}
                hideSorting
                hidePagination
                hideToolbar
                hideVisibilityColumns
                queryKey={learningGroupStructureOptions.queryKey}
                visibilityModelKey={dataGridModel.school_classes}
                selectedRowIds={selectedTestTakers} // האובייקט של ה-State { id: true }
                setSelectedRowIds={setSelectedTestTakers} // פונקציית העדכון
                onRowSelection={setSelectedTestTakers}
                collapse={{
                    show: true,
                    columns: testTakersColumns,
                    showToolbar: false,
                    onCollapse: () => { },
                    data: currentGroup?.test_takers,
                    selectedRowIds: selectedTestTakers, // האובייקט של ה-State { id: true }
                    setSelectedRowIds: setSelectedTestTakers, // פונקציית העדכון
                    onRowSelection: setSelectedTestTakers,
                    showChollapseIcon: true,
                    hideVisibilityColumns: true,
                    hideSorting: true,
                    hidePagination: true,
                    hideToolbar: true,
                }}
            />
        </div>
    )
}

export default Affiliations